<div class="space-y-6 mb-6">
  <h3 class="text-lg font-semibold">
    {{ 'project.steps.rfp.invitationPreview.tabProjectDescription.header' | transloco }}
  </h3>
</div>

<div class="space-y-6" data-testid="rfp-invitation-text-sections">
  @for (section of invitationSections(); track section.key) {
    <div class="space-y-4" [attr.data-testid]="'section-' + section.key">
      <div class="w-full">
        <app-rich-text-editor
          [key]="section.key"
          [tooltipKey]="section.tooltipKey"
          [initialContent]="section.content"
          [saveHandler]="richTextService"
          [disabled]="isButtonDisabled()"
          (statusChange)="onStatusChange()"
          class="w-full"
          [attr.data-testid]="'rich-text-editor-' + section.key"
        >
        </app-rich-text-editor>
      </div>
    </div>
  }
</div>
